import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { SymptomGrid } from './components/SymptomGrid';
import { BrandIntro } from './components/BrandIntro';
import { CredibilityBlock } from './components/CredibilityBlock';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { TreatmentsCatalog } from './components/TreatmentsCatalog';
import { SocialProof } from './components/SocialProof';
import { LiveQA } from './components/LiveQA';
import { Physicians } from './components/Physicians';
import { SymptomGuideCTA } from './components/SymptomGuideCTA';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-orla-bone font-body selection:bg-orla-saffron/30" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Marquee data-id="element-4" />
        <SymptomGrid data-id="element-5" />
        <BrandIntro data-id="element-6" />
        <CredibilityBlock data-id="element-7" />
        <Testimonials data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <FAQ data-id="element-10" />
        <Comparison data-id="element-11" />
        <TreatmentsCatalog data-id="element-12" />
        <SocialProof data-id="element-13" />
        <LiveQA data-id="element-14" />
        <Physicians data-id="element-15" />
        <SymptomGuideCTA data-id="element-16" />
        <Newsletter data-id="element-17" />
        <Footer data-id="element-18" />
      </main>
    </div>;
}